import { useToggle } from "react-use"
import { useRef } from "react"

import { useGetCompanyInfo } from "modules/HRAccount/queries"
import { Icon, Tooltip } from "components"
import { Text } from "ui-kit/components-branded/index"
import style from "modules/HRAccount/AccountManagerInfo/account-manager-info.module.scss"

export function AccountManagerInfo() {
    const [visible, setVisible] = useToggle(false)
    const containerRef = useRef(null)
    const { data } = useGetCompanyInfo()
    if (!data) return null
    const { manager } = data
    return (
        <Tooltip
            overlay={
                <div className={style.overlay}>
                    <div className="mgb-3">
                        <Text>Ваш аккаунт-менеджер</Text> <br />
                        <Text isAccent>{manager.name}</Text>
                    </div>
                    <div>
                        <Text>Электронная почта</Text> <br />
                        <a href={`mailto:${manager.email}`} className="link-secondary-dark">
                            <Text isAccent>{manager.email}</Text>
                        </a>
                    </div>
                    {manager.telegram && (
                        <div className="mgt-3">
                            <Text>Telegram</Text> <br />
                            <a
                                href={`https://t.me/${manager.telegram}`}
                                className="link-secondary-dark"
                            >
                                <Text isAccent>{manager.telegram}</Text>
                            </a>
                        </div>
                    )}
                </div>
            }
            onVisibleChange={setVisible}
            forceTrigger="click"
            placement="top"
            getTooltipContainer={() => containerRef.current ?? document.body}
        >
            <div className={style.circle} ref={containerRef}>
                <Icon type={visible ? "close-big" : "comment"} size={24} fill="#FFF" />
            </div>
        </Tooltip>
    )
}
